import { render, staticRenderFns } from "./AlertaMsj.vue?vue&type=template&id=b076dc3e"
import script from "./AlertaMsj.vue?vue&type=script&lang=js"
export * from "./AlertaMsj.vue?vue&type=script&lang=js"
import style0 from "./AlertaMsj.vue?vue&type=style&index=0&id=b076dc3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports